// @ts-check

import { CELL_COUNT, SIZE } from "./constants.js";

export const ROWS = Object.freeze(
  Array.from({ length: SIZE }, (_, row) =>
    Object.freeze(
      Array.from({ length: SIZE }, (_, column) => row * SIZE + column),
    ),
  ),
);
export const COLUMNS = Object.freeze(
  Array.from({ length: SIZE }, (_, column) =>
    Object.freeze(
      Array.from({ length: SIZE }, (_, row) => row * SIZE + column),
    ),
  ),
);
export const BOXES = Object.freeze(
  Array.from({ length: SIZE }, (_, box) => {
    const rowStart = Math.floor(box / 3) * 3;
    const columnStart = (box % 3) * 3;
    return Object.freeze(
      Array.from(
        { length: SIZE },
        (_, offset) =>
          (rowStart + Math.floor(offset / 3)) * SIZE +
          columnStart +
          (offset % 3),
      ),
    );
  }),
);
export const UNITS = Object.freeze([...ROWS, ...COLUMNS, ...BOXES]);
export const BOX_INDEX = new Uint8Array(CELL_COUNT);
export const UNITS_BY_CELL = Object.freeze(
  Array.from({ length: CELL_COUNT }, (_, cell) => {
    const row = Math.floor(cell / SIZE);
    const column = cell % SIZE;
    const box = Math.floor(row / 3) * 3 + Math.floor(column / 3);
    BOX_INDEX[cell] = box;
    return Object.freeze([ROWS[row], COLUMNS[column], BOXES[box]]);
  }),
);
export const PEERS_BY_CELL = Object.freeze(
  Array.from({ length: CELL_COUNT }, (_, cell) => {
    const peers = new Set(UNITS_BY_CELL[cell].flat());
    peers.delete(cell);
    return Object.freeze([...peers].sort((a, b) => a - b));
  }),
);

export function cellCoordinates(cell) {
  return {
    row: Math.floor(cell / SIZE),
    column: cell % SIZE,
    box: BOX_INDEX[cell],
  };
}

export function unitDescriptor(unitIndex) {
  if (unitIndex < 9) return { type: "row", index: unitIndex };
  if (unitIndex < 18) return { type: "column", index: unitIndex - 9 };
  return { type: "box", index: unitIndex - 18 };
}
